import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClientePipeSharedModule } from '../../pipes/cliente-pipe-shared.module';
import { ClienteCentralCompraParticipanteFormModule } from '../participante/form';

import { ClienteCentralCompraFormComponent } from './cliente-central-compra-form.component';
import { ClienteCentralCompraFormModalComponent } from './form-modal';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule,
        ClienteCentralCompraParticipanteFormModule
    ],
    declarations: [
        ClienteCentralCompraFormComponent,
        ClienteCentralCompraFormModalComponent
    ],
    exports: [
        ClienteCentralCompraFormModalComponent
    ]
})
export class ClienteCentralCompraFormModule { }
